import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import logo from 'assets/img/gegee/gegeenSoft.png';
import Cookies from 'js-cookie';

const Logo = ({ at, width, className, textClass, ...rest }) => {
  const getCompany = Cookies.get('company');
  const company = getCompany ? JSON.parse(getCompany) : null;
  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none z-3',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img
          className="me-2"
          src={company?.logo?.url ? company?.logo?.url : logo}
          alt="Logo"
          width={width}
        />
        <span className={classNames('font-sans-serif ', textClass)}>
          {company?.name ? company?.name : 'Gegee'}
        </span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
